/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import { firestore } from "../services/firebase/firebase";

//This to detect clientId and base on its change switch chatbot
function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		if (pair[0] === variable) { return pair[1]; }
	}
	return (false);
}

//Get the clientId to use fo MicrosoftLogin
//from firestore collection chatbots
//document chatbotId
//key clientIdSsoMs
let clientId = getQueryVariable("id") ? getQueryVariable("id") : "1001"
const chatbotDataTmp = await firestore
	.collection("chatbots")
	.doc(clientId)
	.get()

const chatbotDocVal = chatbotDataTmp.data()
console.log("GET CHATBOT INFO", chatbotDocVal);
if (!chatbotDocVal) {
	console.log("authConfig no chatbotDocVal")
}
console.log("authConfig clientIdSsoMs", chatbotDocVal?.clientIdSsoMs)
console.log("authConfig clientId", clientId)
const tmpClientIdSsoMs = chatbotDocVal?.clientIdSsoMs;

//TODO:
//tmpClientIdSsoMs is the clientIdSsoMs from the chatbotDocVal
//this expect that when creating a chatbot this value is already know from Groundfloor
//and get by an API while creating a new chatbot for the client
console.log("tmpClientIdSsoMs", tmpClientIdSsoMs)

//TODO:
//to make dynamic the clientId is expected that in groundFloor the array of redirectUri is already set
//this means that when creating a chatbot sail need to call one API in groundFloor to add 7 redirecs uri
//for the 3 environments (DEV, PROD, STAGE)
//DEV
//`https://sail-dev-62f69.firebaseapp.com/?id=${clientId}`  //clientId is the chatbotId
//`https://sail-dev-open.firebaseapp.com/?id=${clientId}`  //clientId is the chatbotId
//`http://localhost:3000/?id=${clientId}`  //clientId is the chatbotId

//STAGE
//`https://sail-staging.......firebaseapp.com/?id=${clientId}`  //clientId is the chatbotId
//`https://sail-staging-open----.firebaseapp.com/?id=${clientId}`  //clientId is the chatbotId

//PROD
//`https://agent.sail.cx/?id=${clientId}`  //clientId is the chatbotId
//`https://eco-seeker......com/?id=${clientId}`  //clientId is the chatbotId

let baseURLsso = "";

if (process.env.REACT_APP_PROJECT_ID === "sail-dev-62f69") {
	//DEV
	// baseURLsso = "https://sail-dev-open.firebaseapp.com/"
    baseURLsso = "https://dev-agent.sail.cx/?view=full";

} else if (process.env.REACT_APP_PROJECT_ID === "sail-staging-4dcfb") {
	//STAGE
	// baseURLsso = "https://sail-staging-open.firebaseapp.com/"
    baseURLsso = "https://staging-agent.sail.cx/?view=full";
} else if (process.env.REACT_APP_PROJECT_ID === "eco-seeker-310618") {
	//PRODUCTION
	// baseURLsso = "https://sail-live-open.firebaseapp.com/";
    baseURLsso = "https://agent.sail.cx/?view=full";
}
console.log("baseURLsso", baseURLsso);

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
	auth: {
		//IN DEV use Premises, in STAGE and PROD use Sofina
		// clientId: process.env.REACT_APP_PROJECT_ID === "sail-dev-62f69" ? "1dadd136-e76c-4a32-bf5b-ed82ba32f883" : "94ae8535-733a-4d84-82b0-d2056a9a47c5",

		//Sofina
		clientId: "94ae8535-733a-4d84-82b0-d2056a9a47c5",
		//Premise
		// clientId: "1dadd136-e76c-4a32-bf5b-ed82ba32f883",
		//generalize for all clients
		// clientId: `${tmpClientIdSsoMs}`,

		//Premise
		// clientId: "1dadd136-e76c-4a32-bf5b-ed82ba32f883",
		authority: "https://login.microsoftonline.com/organizations",

		// redirectUri: `${baseURLsso}?id=${clientId}`,

		//DEV
		// redirectUri: "https://sail-dev-62f69.firebaseapp.com/?id=494cd860-7d72-4e9c-8dc3-77e98a04e696",
		// redirectUri: "https://sail-dev-open.firebaseapp.com/?id=494cd860-7d72-4e9c-8dc3-77e98a04e696",
		// redirectUri: `https://sail-dev-open.firebaseapp.com/?id=${clientId}`,
		// redirectUri: "http://localhost:3000/?id=494cd860-7d72-4e9c-8dc3-77e98a04e696", //for LOCAL
		/**
		* The redirect URI 'http://localhost:3000/?id=494cd860-7d72-4e9c-8dc3-77e98a04e696' specified in the request does not match the redirect URIs configured for the application '1dadd136-e76c-4a32-bf5b-ed82ba32f883'
		*/

		//PRODUCTION
		redirectUri: "https://agent.sail.cx/?view=full&id=08ac1804-f0d3-4b63-a15d-db08a3981782"
		// redirectUri: "http://localhost:3000/?view=full&id=08ac1804-f0d3-4b63-a15d-db08a3981782"
		// redirectUri: "http://localhost:3333/?view=full&id=08ac1804-f0d3-4b63-a15d-db08a3981782"

	},
	cache: {
		cacheLocation: "sessionStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						console.info(message);
						return;
					case LogLevel.Verbose:
						console.debug(message);
						return;
					case LogLevel.Warning:
						console.warn(message);
						return;
					default:
						return;
				}
			}
		}
	}
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
	// scopes: ["User.Read"]

	//IN DEV use Premises, in STAGE and PROD use Sofina
	// scopes: process.env.REACT_APP_PROJECT_ID === "sail-dev-62f69" ? ["api://1dadd136-e76c-4a32-bf5b-ed82ba32f883/sso"] : ["api://94ae8535-733a-4d84-82b0-d2056a9a47c5/sso"],
	//Sofina
	scopes: ["api://94ae8535-733a-4d84-82b0-d2056a9a47c5/sso"]
	//Premise
	// scopes: ["api://1dadd136-e76c-4a32-bf5b-ed82ba32f883/sso"]
	//generalize for all clients
	// scopes: [`api://${tmpClientIdSsoMs}/sso`]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
	graphMeEndpoint: "https://graph.microsoft.com/v1.0/me" //e.g. https://graph.microsoft.com/v1.0/me
};
